<template>
    <div>
        <table class="table table-bordered">
            <thead>
                <th v-for="(item, k) in TABLE_CONDITION_BLOCK.headers" :key="k" style="background: #ededed" :style="`min-width: ${item.width}px`">
                    <div class="d-flex align-items-center">{{ item.label }}</div>
                </th>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <Multiselect
                            :id="`select-block-saved`"
                            :value.sync="var_table.block"
                            :options="listBlockConditionComputed"
                            :config="{ trackBy: 'idIndex', label: 'block_name', error: false, isRemove: true }"
                            @select="resetConditionType"
                        />
                    </td>
                    <td>
                        <div>
                            <Multiselect
                                :id="`select-type_condition`"
                                :value.sync="var_table.condition_type"
                                :options="TYPE_CONDITION_IN_TABLE"
                                @open="handleOpenTypeCondition(var_table.block)"
                                @select="resetConditionValue"
                                :config="{ trackBy: 'value', label: 'name', error: false, isRemove: true }"
                            />
                        </div>
                    </td>
                    <td>
                        <div v-if="![5, 6].includes(var_table.condition_type?.id)">
                            <template
                                v-if="
                                    [
                                        ALL_BLOCK_TYPE.BLOCK_SELECT,
                                        ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                                        ALL_BLOCK_TYPE.BLOCK_RADIO,
                                        ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
                                        ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY
                                    ].includes(var_table.block?.block_type)
                                "
                            >
                                <Multiselect
                                    style="min-width: 180px"
                                    :id="`select-type_condition-`"
                                    :class="{ 'is-invalid': customMessageError ?? false }"
                                    :value.sync="var_table.value.select_value_block"
                                    :options="onHandleGetOption(var_table.block?.block_type, var_table.block?.option_value, var_table.block)"
                                    :config="{
                                        trackBy: 'id',
                                        label: 'value',
                                        multiple: conditionTypeOther.includes(var_table.condition_type?.id),
                                        error: false,
                                        isRemove: true
                                    }"
                                />
                                <div v-if="customMessageError" :class="`d-block invalid-feedback mt-1`">
                                    {{ customMessageError }}
                                </div>
                            </template>
                            <template v-else-if="[ALL_BLOCK_TYPE.BLOCK_DATE].includes(var_table.block?.block_type)">
                                <PickerDate
                                    :id="`searchBlockDate`"
                                    :model.sync="var_table.value.value_input"
                                    :config="{
                                        error: customMessageError ?? false
                                    }"
                                />
                                <div v-if="customMessageError" :class="`d-block invalid-feedback mt-1`">
                                    {{ customMessageError }}
                                </div>
                            </template>
                            <template v-else-if="var_table.block?.block_type == ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER">
                                <div class="d-flex flex-nowrap">
                                    <InputText
                                        :id="`InputPhone-1-Form-`"
                                        :model.sync="var_table.value.value_phone_1"
                                        style=""
                                        :config="{
                                            maxlength: 5,
                                            isNumber: true,
                                            error: customMessageError ?? false
                                        }"
                                    />
                                    <div class="p-1" style="font-size: 20px">-</div>
                                    <InputText
                                        :id="`InputPhone-2-Form-`"
                                        :model.sync="var_table.value.value_phone_2"
                                        style=""
                                        :config="{
                                            maxlength: 4,
                                            isNumber: true,
                                            error: customMessageError ?? false
                                        }"
                                    />
                                    <div class="p-1" style="font-size: 20px">-</div>
                                    <InputText
                                        :id="`InputPhone-3-Form-`"
                                        :model.sync="var_table.value.value_phone_3"
                                        style=""
                                        :config="{
                                            maxlength: 4,
                                            isNumber: true,
                                            error: customMessageError ?? false
                                        }"
                                    />
                                </div>
                                <div v-if="customMessageError" :class="`d-block invalid-feedback mt-1`">
                                    {{ customMessageError }}
                                </div>
                            </template>
                            <template v-else-if="var_table.block?.block_type == ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE">
                                <div class="d-flex align-items-center flex-nowrap">
                                    <InputText
                                        :id="`InputPostcode-1-Form-`"
                                        :class="{ 'is-invalid': customMessageError ?? false }"
                                        :model.sync="var_table.value.value_postal_code_1"
                                        style="max-width: 80px"
                                        :config="{
                                            maxlength: 3,
                                            isNumber: true,
                                            error: customMessageError ?? false
                                        }"
                                    />
                                    <div class="p-1" style="font-size: 20px">-</div>
                                    <InputText
                                        :id="`InputPostcode-2-Form-`"
                                        :class="{ 'is-invalid': customMessageError ?? false }"
                                        :model.sync="var_table.value.value_postal_code_2"
                                        style="max-width: 80px"
                                        :config="{
                                            maxlength: 4,
                                            isNumber: true,
                                            error: customMessageError ?? false
                                        }"
                                    />
                                </div>
                                <div v-if="customMessageError" :class="`d-block invalid-feedback mt-1`">
                                    {{ customMessageError }}
                                </div>
                            </template>
                            <template v-else>
                                <InputText
                                    :id="`input-value_input-`"
                                    style="min-width: 180px"
                                    :model.sync="var_table.value.value_input"
                                    :config="{
                                        error: customMessageError ?? false
                                    }"
                                />
                                <div v-if="customMessageError" :class="`d-block invalid-feedback mt-1`">
                                    {{ customMessageError }}
                                </div>
                            </template>
                        </div>
                    </td>
                    <td>
                        <div v-if="var_table?.block">
                            <div class="text-left text-nowrap">
                                <button type="button" class="btn btn-outline-success" @click="handleAddConditionBlock()">
                                    <span>{{ $t('managerForm.settingPage.add') }}</span>
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="formBlock.input_condition.conditions.length > 0" class="d-flex justify-content-center align-items-center flex-column">
            <span style="font-size: 28px">
                <i class="fa fa-solid fa-caret-down" style="color: #cccccc"></i>
            </span>
            <p>{{ $t('managerForm.settingPage.presetConditions') }}</p>
        </div>

        <div v-if="formBlock.input_condition.conditions.length > 0" class="set_up">
            <table class="table table-bordered table-result">
                <thead>
                    <th v-for="(item, k) in TABLE_CONDITION_BLOCK.headers" :key="k" style="background: #ededed" :style="`min-width: ${item.width}px`">
                        <div class="d-flex align-items-center">{{ item.label }}</div>
                    </th>
                </thead>
                <tbody>
                    <tr v-for="(resultCondition, idx) in formBlock.input_condition.conditions" :key="`tr---${idx}`">
                        <td>
                            <div>
                                {{ resultCondition.block.block_name }}
                            </div>
                        </td>
                        <td>
                            <div>
                                {{ returnConditionType(resultCondition.condition_type) }}
                            </div>
                        </td>
                        <td>
                            <div>
                                {{ returnConditionValue(resultCondition.value, resultCondition.block.block_type) }}
                            </div>
                        </td>
                        <td>
                            <div>
                                <div class="text-left text-nowrap btn">
                                    <div class="d-flex flex-column align-items-center delete--condition" @click="deleteConditionBlock(idx)">
                                        <div class="rounded-circle bg_trash--condition">
                                            <span class="d-flex justify-content-center align-items-center h-100">
                                                <i class="fa fa-trash"></i>
                                            </span>
                                        </div>
                                        <span class="clr--text--delete">{{ $t('btn.delete') }}</span>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { TABLE_CONDITION_BLOCK } from '../constants';
import { BLOCK_COMMON } from '@/config/constants';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { InputText } from '@/components/Input';
import PickerDate from '@/components/DateCustoms/PickerDate/main.vue';
import { showMessage } from '@/utils/messages';

import Multiselect from '@/components/Multiselect/main.vue';
const VALUE_ETC = 'etc';
const VALUE_NAC = 'nac';
export default {
    name: 'TableCondition',
    components: {
        Multiselect,
        InputText,
        PickerDate
    },
    props: {
        formBlock: {
            type: Object,
            required: true,
            default: () => null
        },
        configFormInput: {
            type: Object,
            required: true,
            default: () => null
        },
        listBlockCondition: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            TABLE_CONDITION_BLOCK: TABLE_CONDITION_BLOCK,
            TYPE_CONDITION_IN_TABLE: [],
            BLOCK_COMMON: BLOCK_COMMON,
            var_table: {
                block: null,
                condition_type: null,
                value: {
                    select_value_block: null,
                    value_input: null,
                    value_phone_1: null,
                    value_phone_2: null,
                    value_phone_3: null,
                    value_postal_code_1: null,
                    value_postal_code_2: null
                }
            },
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            conditionTypeOther: [7, 8],
            customMessageError: ''
        };
    },
    methods: {
        initVarTableFilter() {
            return {
                block: null,
                condition_type: null,
                value: {
                    select_value_block: null,
                    value_input: null,
                    value_phone_1: null,
                    value_phone_2: null,
                    value_phone_3: null,
                    value_postal_code_1: null,
                    value_postal_code_2: null
                }
            };
        },
        onInitFilterConditions() {
            return [
                { id: 1, value: 'equal', name: 'イコール' },
                { id: 2, value: 'start_with', name: '前方一致' },
                { id: 3, value: 'end_with', name: '後方一致' },
                { id: 4, value: 'include', name: '含む' },
                { id: 5, value: 'no_answer', name: '回答なし' },
                { id: 6, value: 'has_answer', name: '回答あり' },
                { id: 7, value: 'select_one', name: 'いずれか選択' },
                { id: 8, value: 'select_all', name: 'すべて選択' },
                { id: 9, value: 'gt_equal', name: 'より後' },
                { id: 10, value: 'lt_equal', name: 'より前' }
            ];
        },
        returnConditionType(value) {
            const condition = this.onInitFilterConditions().find((item) => item.value === value);
            return condition ? condition.name : value;
        },
        returnConditionValue(value, blockType) {
            switch (blockType) {
                case ALL_BLOCK_TYPE.BLOCK_SELECT:
                case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                case ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY:
                    return value.select_value_block && value.select_value_block.map((v) => v.value).join(', ');
                default:
                    return value.value_input;
            }
        },
        returnPhoneNumber(value) {
            if (value.value_phone_1 && value.value_phone_2 && value.value_phone_3) {
                return `${value.value_phone_1 ?? ''}-${value.value_phone_2 ?? ''}-${value.value_phone_3 ?? ''}`;
            } else if (value.value_phone_1 && value.value_phone_2) {
                return `${value.value_phone_1 ?? ''}-${value.value_phone_2 ?? ''}`;
            } else if (value.value_phone_1) {
                return `${value.value_phone_1 ?? ''}-`;
            } else {
                return '';
            }
        },
        returnValueForConditionBlock(value, blockType) {
            switch (blockType) {
                case ALL_BLOCK_TYPE.BLOCK_SELECT:
                case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                case ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY:
                    return { select_value_block: value.select_value_block };
                case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                    return {
                        value_input: this.returnPhoneNumber(value)
                    };
                case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                    return { value_input: value.value_postal_code_1 ? `${value.value_postal_code_1 ?? ''}-${value.value_postal_code_2 ?? ''}` : '' };
                default:
                    return { value_input: value.value_input };
            }
        },
        handleAddConditionBlock() {
            if (!this.var_table.condition_type) {
                return;
            }
            if (this.var_table.block.input_condition.conditions.length > 0) {
                const isBlockUsedInOtherCondition = this.var_table.block.input_condition.conditions.some(
                    (item) => item.block.id === this.formBlock.id
                );
                if (isBlockUsedInOtherCondition) {
                    showMessage(422, this.$bvToast, `入力条件がブロック「${this.var_table.block.block_name}」との間でループしています。`);
                    return;
                }
            }
            if (
                [
                    ALL_BLOCK_TYPE.BLOCK_SELECT,
                    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                    ALL_BLOCK_TYPE.BLOCK_RADIO,
                    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
                    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY
                ].includes(this.var_table.block.block_type)
            ) {
                if (![5, 6].includes(this.var_table.condition_type?.id)) {
                    if (!this.var_table.value.select_value_block || this.var_table.value.select_value_block.length === 0) {
                        this.customMessageError = '条件の選択肢を選択してください。';
                        return;
                    } else {
                        this.customMessageError = '';
                    }
                }
            } else if (this.var_table.block.block_type === ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER) {
                if ([1, 2].includes(this.var_table.condition_type?.id)) {
                    if (this.var_table.condition_type?.id === 1) {
                        if (!this.var_table.value.value_phone_1 || !this.var_table.value.value_phone_2 || !this.var_table.value.value_phone_3) {
                            this.customMessageError = '条件の値に電話番号を入力してください。';
                            return;
                        }
                    } else {
                        if (!this.var_table.value.value_phone_1) {
                            this.customMessageError = '条件の値に電話番号を入力してください。';
                            return;
                        } else if (this.var_table.value.value_phone_1 && this.var_table.value.value_phone_3 && !this.var_table.value.value_phone_2) {
                            this.customMessageError = '条件の値に電話番号を入力してください。';
                            return;
                        } else {
                            this.customMessageError = '';
                        }
                    }
                }
            } else if (this.var_table.block.block_type === ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE) {
                if ([1, 2].includes(this.var_table.condition_type?.id)) {
                    if (this.var_table.condition_type?.id === 1) {
                        if (!this.var_table.value.value_postal_code_1) {
                            this.customMessageError = '条件の値を入力してください。';
                            return;
                        } else if (!this.var_table.value.value_postal_code_2) {
                            this.customMessageError = '条件の値に7桁の郵便番号を入力してください。';
                            return;
                        } else if ((this.var_table.value.value_postal_code_1 + this.var_table.value.value_postal_code_2).length < 7) {
                            this.customMessageError = '条件の値に7桁の郵便番号を入力してください。';
                            return;
                        } else {
                            this.customMessageError = '';
                        }
                    } else {
                        if (!this.var_table.value.value_postal_code_1) {
                            this.customMessageError = '条件の値を入力してください。';
                            return;
                        } else if (this.var_table.value.value_postal_code_1 && this.var_table.value.value_postal_code_1.length < 3) {
                            this.customMessageError = '条件の値に前方3桁以上の郵便番号を入力してください。';
                            return;
                        } else {
                            this.customMessageError = '';
                        }
                    }
                }
            } else {
                if ([1, 2, 3, 4, 9, 10].includes(this.var_table.condition_type?.id)) {
                    if (!this.var_table.value.value_input || this.var_table.value.value_input.trim() === '') {
                        this.customMessageError = '条件の値を入力してください。';
                        return;
                    } else {
                        this.customMessageError = '';
                    }
                }
            }

            this.formBlock.input_condition.conditions.push({
                block: {
                    id: this.var_table.block.id,
                    block_type: this.var_table.block.block_type,
                    block_name: this.var_table.block.block_name,
                    ...(this.var_table.block.block_type_name && {
                        block_type_name: this.var_table.block.block_type_name
                    })
                },
                condition_type: this.var_table.condition_type.value,
                order_index: this.var_table.block.order_index,
                value: this.returnValueForConditionBlock(this.var_table.value, this.var_table.block.block_type)
            });
            this.var_table = this.initVarTableFilter();
            this.customMessageError = '';
            this.$emit('update:formBlock', this.formBlock);
        },
        resetConditionType() {
            this.var_table.condition_type = null;
            this.var_table.value = {
                select_value_block: null,
                value_input: null,
                value_phone_1: null,
                value_phone_2: null,
                value_phone_3: null,
                value_postal_code_1: null,
                value_postal_code_2: null
            };
            this.customMessageError = '';
        },
        resetConditionValue() {
            this.var_table.value = {
                select_value_block: null,
                value_input: null,
                value_phone_1: null,
                value_phone_2: null,
                value_phone_3: null,
                value_postal_code_1: null,
                value_postal_code_2: null
            };
            this.customMessageError = '';
        },
        deleteConditionBlock(index) {
            this.formBlock.input_condition.conditions.splice(index, 1);
            if (this.formBlock.input_condition.conditions.length === 0) {
                this.formBlock.input_condition.status = 1;
            }
            this.$emit('update:formBlock', this.formBlock);
        },

        handleOpenTypeCondition(evtBlock) {
            if (!evtBlock?.id) {
                this.TYPE_CONDITION_IN_TABLE = [];
                return;
            }
            switch (evtBlock.block_type) {
                case ALL_BLOCK_TYPE.BLOCK_INPUT:
                case ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX:
                case ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION:
                case ALL_BLOCK_TYPE.BLOCK_FULL_NAME:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [1, 2, 3, 4, 5, 6].includes(item.id);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                case ALL_BLOCK_TYPE.BLOCK_SELECT:
                case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
                case ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [5, 6, 7].includes(item.id);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_TEXTAREA:
                case ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [5, 6].includes(item.id);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [5, 6, 7, 8].includes(item.id);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_DATE:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [1, 5, 6, 9, 10].includes(item.id);
                    });
                    break;
                case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [1, 2, 5, 6].includes(item.id);
                    });
                    break;
                case this.SUBMITED_AT:
                case this.UPDATED_AT:
                    this.TYPE_CONDITION_IN_TABLE = this.onInitFilterConditions().filter((item) => {
                        return [1, 9, 10].includes(item.id);
                    });
                    break;
            }
        },
        onHandleGetOption(blockType, options, blockOrigin) {
            if (!blockType || !options) return [];
            const optionsValue = options.map((item) => {
                item.value_search = item.value;
                return item;
            });
            switch (blockType) {
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                    if (blockOrigin.setting_others.other_use) {
                        return [
                            ...optionsValue,
                            {
                                id: VALUE_ETC,
                                unique_key: VALUE_ETC,
                                value_search: blockOrigin.setting_others.label_other,
                                value: blockOrigin.setting_others.label_other
                            }
                        ];
                    } else {
                        return optionsValue;
                    }

                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX: {
                    const condition_1 = blockOrigin.setting_others.other_use && blockOrigin.setting_others.uncheck_use;
                    const condition_2 = blockOrigin.setting_others.other_use && !blockOrigin.setting_others.uncheck_use;
                    const condition_3 = !blockOrigin.setting_others.other_use && blockOrigin.setting_others.uncheck_use;
                    if (condition_1) {
                        return [
                            ...optionsValue,
                            {
                                id: VALUE_ETC,
                                unique_key: VALUE_ETC,
                                value_search: blockOrigin.setting_others.label_other,
                                value: blockOrigin.setting_others.label_other
                            },
                            {
                                id: VALUE_NAC,
                                unique_key: VALUE_NAC,
                                value_search: blockOrigin.setting_others.label_uncheck,
                                value: blockOrigin.setting_others.label_uncheck
                            }
                        ];
                    }
                    if (condition_2) {
                        return [
                            ...optionsValue,
                            {
                                id: VALUE_ETC,
                                unique_key: VALUE_ETC,
                                value_search: blockOrigin.setting_others.label_other,
                                value: blockOrigin.setting_others.label_other
                            }
                        ];
                    }
                    if (condition_3) {
                        return [
                            ...optionsValue,
                            {
                                id: VALUE_NAC,
                                unique_key: VALUE_NAC,
                                value_search: blockOrigin.setting_others.label_uncheck,
                                value: blockOrigin.setting_others.label_uncheck
                            }
                        ];
                    }
                    return optionsValue;
                }

                default:
                    return optionsValue;
            }
        }
    },
    computed: {
        listBlockConditionComputed() {
            return this.listBlockCondition.flatMap((item, index) => {
                if (item.block_type === ALL_BLOCK_TYPE.BLOCK_FULL_NAME) {
                    return [
                        {
                            idIndex: `${index}_first_name`,
                            id: item.id,
                            block_type: item.block_type,
                            block_type_name: 'first_name',
                            block_name: `${item.block_name}(${item.input_format.first_name})`,
                            input_condition: item.input_condition,
                            order_index: item.order_index
                        },
                        {
                            idIndex: `${index}_last_name`,
                            id: item.id,
                            block_type: item.block_type,
                            block_type_name: 'last_name',
                            block_name: `${item.block_name}(${item.input_format.last_name})`,
                            input_condition: item.input_condition,
                            order_index: item.order_index
                        }
                    ];
                }
                return {
                    idIndex: index,
                    id: item.id,
                    block_type: item.block_type,
                    block_name: item.block_name,
                    option_value: item.option_value,
                    input_condition: item.input_condition,
                    setting_others: item.setting_others,
                    order_index: item.order_index
                };
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.delete--condition {
    .bg_trash--condition {
        width: 30px;
        height: 30px;
        background-color: #f6f5f5;
    }

    .clr--text--delete {
        color: #339162;
    }

    &:hover {
        .bg_trash--condition {
            background-color: #dbdbdb;
        }
        .clr--text--delete {
            color: #70be97;
        }
    }
}
.table td {
    padding: 0.75em;
}
.table-result td {
    vertical-align: middle;
}
</style>
